export const HTTP_CODES = {
  ok: 200,
  badRequest: 400,
  unauthorized: 401,
  paymentRequired: 402,
  forbidden: 403,
  notFound: 404,
  notAcceptable: 406,
  conflict: 409,
  gone: 410,
  tooLarge: 413,
  unprocessableEntity: 422,
  internalServerError: 500,
  badGateway: 502,
  gatewayTimeout: 504,
};